const REF_REG = new RegExp(/^([VX]?Q\d+(?:_\d+)?)/, 'i')

export const getLogicData = (tags, codebooks, r, error) =>
  error
    ? { codebook: [], tag: [] }
    : {
        codebook: Object.keys(r.expression.status.codebooks || {})
          .reduce((acc, cur) => {
            r.expression.status.codebooks[cur].alias.length &&
            !codebooks.some(item => item.title.toUpperCase() == cur.toUpperCase())
              ? acc.concat(r.expression.status.codebooks[cur].alias.map(v => `${cur}.${v}`))
              : acc.push(cur)
            return acc
          }, [])
          .concat(
            Object.keys(r.expression.status.tags || {}).reduce((acc, cur) => {
              const codebook = cur.split(': ').shift()
              r.expression.status.tags[cur].alias.length &&
              !codebooks.some(item => item.title.toUpperCase() == codebook)
                ? acc.concat(r.expression.status.tags[cur].alias.map(v => `${codebook}.${v}`))
                : acc.push(codebook)
              return acc
            }, [])
          )
          .filter((x, i, a) => a.indexOf(x) == i),
        tag: Object.keys(r.expression.status.tags || {})
          .reduce((acc, cur) => {
            r.expression.status.tags[cur].alias.length &&
            !tags.manual.some(item => item.toUpperCase() == cur.toUpperCase())
              ? acc.concat(r.expression.status.tags[cur].alias.map(v => `${cur}.${v}`))
              : acc.push(cur)
            return acc
          }, [])
          .filter((x, i, a) => a.indexOf(x) == i)
      }

export const getRefs = r =>
  Object.keys(r.expression.status.refs)
    .filter(v => null !== v.match(REF_REG))
    .concat(r.expression.status.errors.filter(v => 'ref' == v.type && null !== v.text.match(REF_REG)).map(v => v.text))
    .filter((x, i, a) => a.indexOf(x) == i)

export const getClustersRefs = (clusters, r) =>
  Object.keys(r.expression.status.refs)
    .filter(v =>
      clusters.some(c => {
        const reg = new RegExp(`^${c.qid}(?:SQ(\\d+))?R$`, 'i')
        return null !== v.match(reg)
      })
    )
    .concat(r.expression.status.errors.filter(v => 'cluster' == v.type).map(v => `${v.scope.toUpperCase()}R`))
    .map(v => {
      const indexes = r.expression.status.tokens.map((t, i) => (t.match == v ? i + 2 : '')).filter(String)
      const titles = indexes.map(index => r.expression.status.tokens[Number(index)].match.slice(1, -1))
      return titles.map(title => [v, title])
    })
    .filter((x, i, a) => a.findIndex(v => v[0] == x[0] && v[1] == x[1]) == i)
